import { baseStyles } from './baseStyles';

/**
 * Merges the style computed for the component with the sx property value
 * It will also inject global styles that should be applied to all affected components
 * This is especially useful in the case where the baselineCSS isn't injected
 * @param style The style for the component
 * @param sx The sx style property
 */
export const mergeSxStyle = (style, sx) => {
  const mergedStyle = [style, ...(Array.isArray(sx) ? sx : [sx])];
  mergedStyle.push(baseStyles);
  return mergedStyle;
};